<template>
    <div>
        <label class="kgr-radio kgr-radio--inline">
            <input
                type="radio"
                value="none"
                :checked="isNone"
                :disabled="disabled"
                class="kgr-radio__control"
                @input="onInput"
                @click="$emit('expand', true)"
            />
            <div class="kgr-radio__label">{{ $t('nein') }}</div>
        </label>

        <label class="kgr-radio kgr-radio--inline">
            <input
                type="radio"
                value="byChoice"
                :checked="isByChoice"
                :disabled="disabled"
                class="kgr-radio__control"
                @input="onInput"
                @click="$emit('expand', false)"
            />
            <div class="kgr-radio__label">{{ $t('freiwillig') }}</div>
        </label>

        <label class="kgr-radio kgr-radio--inline">
            <input
                type="radio"
                value="byMissingDocuments"
                :checked="isByMissingDocuments"
                :disabled="disabled"
                class="kgr-radio__control"
                @input="onInput"
                @click="$emit('expand', false)"
            />
            <div class="kgr-radio__label">{{ $t('aufgrund fehlender Unterlagen') }}</div>
        </label>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            required: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        isNone() {
            return this.value === 'none';
        },
        isByChoice() {
            return this.value === 'byChoice';
        },
        isByMissingDocuments() {
            return this.value === 'byMissingDocuments';
        },
    },
    methods: {
        onInput(event) {
            this.$emit('input', event.target.value);
            this.$nextTick(() => {
                this.$emit('post-input', event.target.value);
            });
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    label {
    padding-right: 30px;
    position: relative;
    top: -3px;
}
</style>
